"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeridianFlow;
(function (MeridianFlow) {
    MeridianFlow["ACCESS_MERIDIAN"] = "access meridian";
    MeridianFlow["PROVISIONING"] = "provisioning";
    MeridianFlow["MERGE_ACCOUNTS"] = "merge accounts";
})(MeridianFlow = exports.MeridianFlow || (exports.MeridianFlow = {}));
var MeridianTrueOrFalse;
(function (MeridianTrueOrFalse) {
    MeridianTrueOrFalse["TRUE"] = "TRUE";
    MeridianTrueOrFalse["FALSE"] = "FALSE";
})(MeridianTrueOrFalse = exports.MeridianTrueOrFalse || (exports.MeridianTrueOrFalse = {}));
var VerifyCredentialFlow;
(function (VerifyCredentialFlow) {
    VerifyCredentialFlow["VerifyCredential"] = "VerifyCredential";
    VerifyCredentialFlow["ResetAccessVerifyCredential"] = "ResetAccessVerifyCredential";
})(VerifyCredentialFlow = exports.VerifyCredentialFlow || (exports.VerifyCredentialFlow = {}));
var ConferenceProductType;
(function (ConferenceProductType) {
    ConferenceProductType["FlexPass"] = "flex-pass-conference";
    ConferenceProductType["Online"] = "online-conference";
    ConferenceProductType["Onsite"] = "onsite-conference";
})(ConferenceProductType = exports.ConferenceProductType || (exports.ConferenceProductType = {}));
var ExamProductType;
(function (ExamProductType) {
    ExamProductType["Exam"] = "exam-kryterion";
    ExamProductType["ExamRetake"] = "exam-retake-kryterion";
    ExamProductType["ExamPart1"] = "exam-part-1-kryterion";
    ExamProductType["ExamPart2"] = "exam-part-2-kryterion";
    ExamProductType["ExamRetakePart1"] = "exam-retake-part-1-kryterion";
    ExamProductType["ExamRetakePart2"] = "exam-retake-part-2-kryterion";
})(ExamProductType = exports.ExamProductType || (exports.ExamProductType = {}));
var PublicationProductType;
(function (PublicationProductType) {
    PublicationProductType["Ebook"] = "e-book";
})(PublicationProductType = exports.PublicationProductType || (exports.PublicationProductType = {}));
var StandingOrderStatus;
(function (StandingOrderStatus) {
    StandingOrderStatus["NEW"] = "New";
    StandingOrderStatus["FIRST_EMAIL_SENT"] = "First email sent";
    StandingOrderStatus["SECOND_EMAIL_SENT"] = "Second email sent";
    StandingOrderStatus["ORDER_PLACED"] = "Order placed";
})(StandingOrderStatus = exports.StandingOrderStatus || (exports.StandingOrderStatus = {}));
var StandingOrderSubscriptionStatus;
(function (StandingOrderSubscriptionStatus) {
    StandingOrderSubscriptionStatus["ACTIVE"] = "Active";
    StandingOrderSubscriptionStatus["CANCELLED"] = "Cancelled";
})(StandingOrderSubscriptionStatus = exports.StandingOrderSubscriptionStatus || (exports.StandingOrderSubscriptionStatus = {}));
var ProcessResult;
(function (ProcessResult) {
    ProcessResult["SUCCESS"] = "Success";
    ProcessResult["FAILED"] = "Failed";
})(ProcessResult = exports.ProcessResult || (exports.ProcessResult = {}));
var Status;
(function (Status) {
    Status["ACTIVE"] = "Active";
    Status["INACTIVE"] = "Inactive";
    Status["AVAILABLE"] = "Available";
    Status["CANCELLED"] = "Cancelled";
    Status["EXPIRED"] = "Expired";
    Status["USED"] = "Used";
    Status["VOID"] = "VOID";
})(Status = exports.Status || (exports.Status = {}));
var RecordOwner;
(function (RecordOwner) {
    RecordOwner["CIMA"] = "CIMA";
    RecordOwner["CIMA_FLP"] = "CIMAFLP";
    RecordOwner["CGMA"] = "CGMA";
    RecordOwner["CGMAX"] = "CGMAX";
})(RecordOwner = exports.RecordOwner || (exports.RecordOwner = {}));
var B2BContact;
(function (B2BContact) {
    B2BContact["N"] = "N";
    B2BContact["Y"] = "Y";
})(B2BContact = exports.B2BContact || (exports.B2BContact = {}));
var ContactType;
(function (ContactType) {
    ContactType["CGMA_DESIGNEE"] = "CGMA Designee";
    ContactType["CGMA_Candidate"] = "CGMA Candidate";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
//# sourceMappingURL=index.js.map